import {isPdfDocument} from "../../../utils/documentUpload";
import UploadPreviewState from "./UploadPreviewState";

const DocumentPreview = ({
  document,
  label,
  onDelete,
  className = "",
  uploading = false,
  progress = 0,
  error = "",
}) => {
  if (!document?.filePath) return null;

  const pdf = document.isPdf ?? isPdfDocument(document);
  const accessibleLabel = label || document.name || "Pièce jointe";

  return (
    <div
      className={`group relative flex h-[160px] w-[200px] flex-col items-center justify-center overflow-hidden rounded-xl border border-[#D6E2EF] bg-white ${className}`}
    >
      <UploadPreviewState uploading={uploading} progress={progress} error={error}>
        <a
          href={document.filePath}
          target="_blank"
          rel="noopener noreferrer"
          className="flex h-full w-full flex-col items-center justify-center gap-2 p-3 text-center"
          aria-label={`Visualiser ${accessibleLabel}`}
          title={`Visualiser ${accessibleLabel}`}
        >
          {pdf ? (
            <>
              <i className="fi fi-rr-file-pdf flex text-5xl text-[#1A64B9]" />
              <span className="max-w-full truncate text-xs font-medium text-[#19295C]">
                {document.name || "Document PDF"}
              </span>
              <span className="text-[11px] font-semibold text-[#1A64B9]">
                Visualiser
              </span>
            </>
          ) : (
            <img
              src={document.filePath}
              alt={accessibleLabel}
              className="h-full w-full object-contain"
            />
          )}
        </a>
      </UploadPreviewState>

      {onDelete && (
        <button
          type="button"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onDelete();
          }}
          className="absolute right-2 top-2 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-red-600 text-white shadow"
          aria-label={`Supprimer ${accessibleLabel}`}
          title="Supprimer"
        >
          <i className="fi fi-rr-trash flex" />
        </button>
      )}
    </div>
  );
};

export default DocumentPreview;
